export const EXTRA_TV_BOX_PRICE = 10;
export const PVR_PRICE = 10;
export const BILL_CREDIT_AMOUNT = 50;
export const LOCKED_BUNDLE_BUILDER_SUBJECT = 'Thanks for your interest in TELUS—here’s your quote';
export const BUNDLE_BUILDER_SOURCE_LABEL = 'Bundle Builder Dynamic Quote';
export const orderedBySort = (items) => [...items].sort((a, b) => (a.sortOrder ?? 999) - (b.sortOrder ?? 999));

// Future Product Pricing Manager work can control sortOrder, badges, highlights, pricing, discounts, and visibility.
export const internetPlans = [
    {
        id: 'internet-1-5g',
        name: '1.5G',
        sortOrder: 10,
        belowLine: 85,
        aboveLine: 95,
        mobilityBelowLine: 75,
        mobilityAboveLine: 85,
        eppMobilityBelowLine: 70,
        eppMobilityAboveLine: 80,
        badgeText: 'Recommended',
        badgeColor: 'success',
        recommended: true,
        highlightNote: 'Best value at the same price as 1G',
        notes: ['Recommended option', 'Free install', '5-year price guarantee'],
        emailDisplayName: 'PureFibre Internet 1.5G',
        emailBullets: ['Unlimited Data Usage'],
        pabAdjustmentAmount: 10,
        emailRegularPrice: null,
        mobilityDiscountEligible: true,
        eppEligible: true,
        emailIncludeInQuoteTable: true,
        emailCategory: 'internet'
    },
    {
        id: 'internet-500',
        name: '500 Mbps',
        sortOrder: 20,
        belowLine: 70,
        aboveLine: 80,
        mobilityBelowLine: 60,
        mobilityAboveLine: 70,
        eppMobilityBelowLine: 55,
        eppMobilityAboveLine: 65,
        badgeText: 'Budget',
        badgeColor: 'info',
        highlightNote: 'Lower monthly price',
        notes: ['Free install'],
        emailDisplayName: 'PureFibre Internet 500 Mbps',
        emailBullets: ['Unlimited Data Usage'],
        pabAdjustmentAmount: 10,
        emailRegularPrice: null,
        mobilityDiscountEligible: true,
        eppEligible: true,
        emailIncludeInQuoteTable: true,
        emailCategory: 'internet'
    },
    {
        id: 'internet-3g',
        name: '3G',
        sortOrder: 30,
        belowLine: 95,
        aboveLine: 110,
        mobilityBelowLine: 85,
        mobilityAboveLine: 100,
        eppMobilityBelowLine: 80,
        eppMobilityAboveLine: 95,
        badgeText: '5-Year Price Lock',
        badgeColor: 'primary',
        hot: true,
        highlightNote: 'Check serviceability before quoting',
        notes: ['Free install', '5-year price guarantee', 'Check serviceability before quoting'],
        emailDisplayName: 'PureFibre Internet 3G',
        emailBullets: ['Unlimited Data Usage'],
        pabAdjustmentAmount: 10,
        emailRegularPrice: null,
        mobilityDiscountEligible: true,
        eppEligible: true,
        emailIncludeInQuoteTable: true,
        emailCategory: 'internet'
    },
    {
        id: 'internet-1g',
        name: '1G',
        sortOrder: 40,
        belowLine: 85,
        aboveLine: 95,
        mobilityBelowLine: 75,
        mobilityAboveLine: 85,
        eppMobilityBelowLine: 70,
        eppMobilityAboveLine: 80,
        badgeText: 'Being phased out',
        badgeColor: 'warning',
        highlightNote: 'Same price as 1.5G',
        notes: ['Same price as 1.5G', 'Being phased out', 'Free install', '5-year price guarantee'],
        emailDisplayName: 'PureFibre Internet 1G',
        emailBullets: ['Unlimited Data Usage'],
        pabAdjustmentAmount: 10,
        emailRegularPrice: null,
        mobilityDiscountEligible: true,
        eppEligible: true,
        emailIncludeInQuoteTable: true,
        emailCategory: 'internet'
    },
    {
        id: 'internet-copper-25-50',
        name: 'TELUS Internet',
        sortOrder: 50,
        belowLine: 55,
        aboveLine: 60,
        mobilityBelowLine: 45,
        mobilityAboveLine: 50,
        eppMobilityBelowLine: 40,
        eppMobilityAboveLine: 45,
        badgeText: 'Copper',
        badgeColor: 'warning',
        highlightNote: 'For non-fibre addresses',
        notes: ['Copper 25-50 Mbps', 'Unlimited Data Usage'],
        cardDescription: 'Copper 25-50 Mbps',
        emailDisplayName: 'TELUS Internet',
        emailBullets: ['Unlimited Data Usage'],
        pabAdjustmentAmount: 5,
        emailRegularPrice: 115,
        mobilityDiscountEligible: true,
        eppEligible: true,
        tvPriceAdjustment: {
            enabled: true,
            amount: 8,
            label: 'Non-fibre Internet TV adjustment'
        },
        emailIncludeInQuoteTable: true,
        emailCategory: 'internet'
    },
    {
        id: 'internet-copper-plus-75-150',
        name: 'TELUS Internet Plus',
        sortOrder: 60,
        belowLine: 60,
        aboveLine: 65,
        mobilityBelowLine: 50,
        mobilityAboveLine: 55,
        eppMobilityBelowLine: 45,
        eppMobilityAboveLine: 50,
        badgeText: 'Copper Plus',
        badgeColor: 'warning',
        highlightNote: 'For non-fibre addresses',
        notes: ['Copper 75-150 Mbps', 'Unlimited Data Usage'],
        cardDescription: 'Copper 75-150 Mbps',
        emailDisplayName: 'TELUS Internet Plus',
        emailBullets: ['Unlimited Data Usage'],
        pabAdjustmentAmount: 5,
        emailRegularPrice: 130,
        mobilityDiscountEligible: true,
        eppEligible: true,
        tvPriceAdjustment: {
            enabled: true,
            amount: 8,
            label: 'Non-fibre Internet TV adjustment'
        },
        emailIncludeInQuoteTable: true,
        emailCategory: 'internet'
    },
    {
        id: 'internet-wireless-home',
        name: 'TELUS Wireless Home Internet',
        sortOrder: 70,
        belowLine: 55,
        aboveLine: 60,
        mobilityBelowLine: 55,
        mobilityAboveLine: 60,
        eppMobilityBelowLine: 55,
        eppMobilityAboveLine: 60,
        badgeText: 'Wireless',
        badgeColor: 'info',
        highlightNote: 'For non-fibre addresses',
        notes: ['Wireless Home Internet', 'Unlimited Data Usage', 'SIM included'],
        cardDescription: 'Wireless Home Internet',
        emailDisplayName: 'TELUS Wireless Home Internet',
        emailBullets: ['Included: SIM', 'Add-ons: Unlimited Data Add-on'],
        pabAdjustmentAmount: 5,
        emailRegularPrice: 95,
        mobilityDiscountEligible: false,
        eppEligible: false,
        tvPriceAdjustment: {
            enabled: true,
            amount: 8,
            label: 'Wireless Home Internet TV adjustment'
        },
        emailIncludeInQuoteTable: true,
        emailCategory: 'internet'
    }
];

export const tvPackages = [
    { id: 'tv-core', packageKey: 'core', name: 'Core', sortOrder: 10, price: 45, regularPrice: 45, pvrIncluded: false, emailBullets: ['Included: TELUS TV Digital Box'], emailIncludeInQuoteTable: true, emailCategory: 'tv' },
    { id: 'tv-core-pick5', packageKey: 'core+pick5', name: 'Core + Pick 5', sortOrder: 20, price: 30, regularPrice: 60, pvrIncluded: false, badgeText: 'Best Value', badgeColor: 'success', emailBullets: ['Included: TELUS TV Digital Box'], emailIncludeInQuoteTable: true, emailCategory: 'tv' },
    { id: 'tv-core-1-premium', packageKey: 'core+1premium', name: 'Core + 1 Premium', sortOrder: 30, price: 40, regularPrice: 60, pvrIncluded: false, emailBullets: ['Included: TELUS TV Digital Box'], emailIncludeInQuoteTable: true, emailCategory: 'tv' },
    { id: 'tv-core-3-theme', packageKey: 'core+3theme', name: 'Core + 3 Theme Packs', sortOrder: 40, price: 43, regularPrice: 68, pvrIncluded: true, badgeText: 'PVR Included', badgeColor: 'primary', emailBullets: ['Included: TELUS TV Digital Box'], emailIncludeInQuoteTable: true, emailCategory: 'tv' },
    { id: 'tv-2-theme-1-premium', packageKey: 'core+2theme+1premium', name: '2 Theme Packs + 1 Premium', sortOrder: 50, price: 50, regularPrice: 75, pvrIncluded: true, emailBullets: ['Included: TELUS TV Digital Box'], emailIncludeInQuoteTable: true, emailCategory: 'tv' },
    { id: 'tv-1-theme-2-premium', packageKey: 'core+1theme+2premium', name: '1 Theme Pack + 2 Premium', sortOrder: 60, price: 55, regularPrice: 80, pvrIncluded: true, emailBullets: ['Included: TELUS TV Digital Box'], emailIncludeInQuoteTable: true, emailCategory: 'tv' },
    { id: 'tv-4-theme-1-premium', packageKey: 'core+4theme+1premium', name: '4 Theme Packs + 1 Premium', sortOrder: 70, price: 63, regularPrice: 88, pvrIncluded: true, emailBullets: ['Included: TELUS TV Digital Box'], emailIncludeInQuoteTable: true, emailCategory: 'tv' },
    { id: 'tv-3-theme-2-premium', packageKey: 'core+3theme+2premium', name: '3 Theme Packs + 2 Premium', sortOrder: 80, price: 70, regularPrice: 95, pvrIncluded: true, emailBullets: ['Included: TELUS TV Digital Box'], emailIncludeInQuoteTable: true, emailCategory: 'tv' },
    { id: 'tv-7-theme-1-premium', packageKey: 'core+7theme+1premium', name: '7 Theme Packs + 1 Premium', sortOrder: 90, price: 78, regularPrice: 103, pvrIncluded: true, emailBullets: ['Included: TELUS TV Digital Box'], emailIncludeInQuoteTable: true, emailCategory: 'tv' },
    { id: 'tv-11-theme-2-premium', packageKey: 'core+theme11+2premium', name: '11 Theme Packs + 2 Premium', sortOrder: 100, price: 108, regularPrice: 133, pvrIncluded: true, emailBullets: ['Included: TELUS TV Digital Box'], emailIncludeInQuoteTable: true, emailCategory: 'tv' }
];

export const tvPackageKeyToManualId = {
    core: 'tv-core',
    'core+pick5': 'tv-core-pick5',
    'core+1premium': 'tv-core-1-premium',
    'core+3theme': 'tv-core-3-theme',
    'core+2theme+1premium': 'tv-2-theme-1-premium',
    'core+1theme+2premium': 'tv-1-theme-2-premium',
    'core+4theme+1premium': 'tv-4-theme-1-premium',
    'core+3theme+2premium': 'tv-3-theme-2-premium',
    'core+7theme+1premium': 'tv-7-theme-1-premium',
    'core+theme11+2premium': 'tv-11-theme-2-premium'
};
export const phonePlans = [
    {
        id: 'phone-lite',
        name: 'Home Phone Lite',
        sortOrder: 10,
        price: 5.89,
        originalPrice: 35.89,
        features: '1 calling feature',
        feeNote: 'Includes required 911 fees',
        badgeText: 'Budget',
        badgeColor: 'info',
        emailDisplayName: 'Home Phone Lite',
        emailBullets: ['Add-ons: E911 and NG911 Provincial Network Fee ($0.20), E911 Municipal Call Answer Fee ($0.69)'],
        emailIncludeInQuoteTable: true,
        emailCategory: 'homePhone'
    },
    {
        id: 'phone-standard',
        name: 'Home Phone',
        sortOrder: 20,
        price: 17.89,
        originalPrice: 42.89,
        features: '7 calling features',
        feeNote: 'Includes required 911 fees',
        badgeText: '7 Features',
        badgeColor: 'primary',
        emailDisplayName: 'Home Phone',
        emailBullets: ['7 Calling Features', 'Includes required 911 fees'],
        emailIncludeInQuoteTable: true,
        emailCategory: 'homePhone'
    }
];

export const longDistanceAddons = [
    { id: 'ld-world-60', name: 'World 60 Unlimited Long Distance', price: 25 },
    { id: 'ld-us-canada-unlimited', name: 'Unlimited US & Canada', price: 17 },
    { id: 'ld-us-canada-300', name: '300 Min US & Canada', price: 10 },
    { id: 'ld-asia', name: 'Asia Long Distance', price: 7 },
    { id: 'ld-india-1000', name: 'India 1000 Min', price: 5 },
    { id: 'ld-philippines-500', name: 'Philippines 500 Min', price: 5 },
    { id: 'ld-china-1000', name: 'China 1000 Min', price: 5 },
    { id: 'ld-international-note', name: 'International calls including US', price: 0, note: '10 cents/min note only' }
];

export const longDistanceAddonIds = longDistanceAddons.map((addon) => addon.id);

export const mobilityCategories = [
    { id: 'koodo', label: 'Koodo' },
    { id: 'telus-personal', label: 'TELUS Personal' },
    { id: 'telus-business', label: 'TELUS Business' },
    { id: 'telus-epp-rbc', label: 'TELUS EPP' }
];

export const mobilityPlans = [
    { id: 'koodo-canada-20gb', name: 'Canada 20GB', sortOrder: 10, category: 'koodo', price: 40, type: 'Koodo', note: 'Simple Koodo line pricing.', badgeText: 'Koodo', badgeColor: 'info' },
    { id: 'koodo-can-us-mex-60gb', name: 'CAN-US-MEX 60GB', sortOrder: 20, category: 'koodo', price: 50, type: 'Koodo', note: 'Simple Koodo roaming plan.', badgeText: 'Roaming', badgeColor: 'primary' },
    { id: 'telus-business-canada-50gb', name: 'Business Canada 50GB', sortOrder: 10, category: 'telus-business', price: 50, type: 'TELUS Mobility', note: 'Business plan.' },
    { id: 'telus-business-can-us-100gb', name: 'Business CAN+US 100GB', sortOrder: 20, category: 'telus-business', price: 55, type: 'TELUS Mobility', note: 'Business plan.' },
    { id: 'telus-business-can-us-mex-150gb', name: 'Business CAN+US+MEXICO 150GB', sortOrder: 30, category: 'telus-business', price: 60, type: 'TELUS Mobility', note: 'Business plan.' },
    { id: 'telus-business-can-global-200gb', name: 'Business CAN-Global 200GB', sortOrder: 40, category: 'telus-business', price: 70, type: 'TELUS Mobility', note: 'Business plan.' },
    { id: 'telus-personal-talk-text', name: 'Personal Talk & Text Only', sortOrder: 10, category: 'telus-personal', price: 25, type: 'TELUS Mobility', note: 'Talk and text only.' },
    { id: 'telus-personal-canada-100gb', name: 'Personal Canada 100GB', sortOrder: 20, category: 'telus-personal', price: 60, type: 'TELUS Mobility', note: 'Personal mobility plan.' },
    {
        id: 'telus-personal-canada-100gb-ffh',
        name: 'Personal Canada 100GB with active FFH',
        sortOrder: 30,
        category: 'telus-personal',
        price: 45,
        type: 'TELUS Mobility',
        note: '$45/line for 1-3 lines; $41.25/line for 4 lines.',
        badgeText: 'HOT',
        badgeColor: 'error',
        hot: true
    },
    {
        id: 'telus-epp-rbc-175gb',
        name: 'EPP/RBC CAN+US+MEXICO 175GB',
        sortOrder: 10,
        category: 'telus-epp-rbc',
        price: 40,
        type: 'TELUS Mobility',
        note: 'First line $40; second and rest $35.',
        badgeText: 'EPP/RBC',
        badgeColor: 'secondary'
    },
    {
        id: 'telus-canada-80gb-home-service',
        name: 'TELUS Canada 80GB requires active home service',
        sortOrder: 40,
        category: 'telus-personal',
        price: 35,
        type: 'TELUS Mobility',
        note: 'Requires active home service.',
        badgeText: 'Home Service',
        badgeColor: 'success'
    }
];

export const securityPlans = [
    {
        id: 'security-control-video',
        name: 'Control Plus Video',
        sortOrder: 10,
        price: 40,
        devices: '1 control panel, 2 window/door sensors, 1 motion sensor, 1 camera, 3 smart devices',
        term: '3-year term',
        badgeText: 'More Devices',
        badgeColor: 'primary'
    },
    {
        id: 'security-secure-video',
        name: 'Secure Plus Video',
        sortOrder: 20,
        price: 35,
        devices: '1 control panel, 2 window/door sensors, 1 motion sensor, 1 camera',
        term: '3-year term',
        badgeText: 'Lower Price',
        badgeColor: 'success'
    }
];

export const addonGroups = [
    {
        id: 'streaming',
        title: 'Streaming',
        sortOrder: 10,
        helperText: 'Streaming add-ons and subscription bundles. Verify account eligibility before quoting.',
        items: [
            { id: 'addon-stream-plus', name: 'Stream+', sortOrder: 10, price: 20, badgeText: 'Streaming', badgeColor: 'primary', note: 'Verify current package inclusions before quoting.' },
            { id: 'addon-stream-plus-premium', name: 'Stream+ Premium', sortOrder: 20, price: 38, badgeText: 'Premium', badgeColor: 'secondary', note: 'Verify current package inclusions before quoting.' },
            { id: 'addon-netflix', name: 'Netflix', sortOrder: 30, price: 20 },
            { id: 'addon-apple-tv', name: 'Apple TV+', sortOrder: 40, price: 13 },
            { id: 'addon-disney', name: 'Disney+', sortOrder: 50, price: 15 },
            { id: 'addon-crave', name: 'Crave', sortOrder: 60, price: 22 },
            { id: 'addon-hayu', name: 'Hayu', price: 7 }
        ]
    },
    {
        id: 'tv-addons',
        title: 'TV Add-ons / Theme Packs',
        sortOrder: 20,
        helperText: 'Extra theme packs, premium packs, and specialty channels.',
        items: [
            { id: 'addon-regular-theme-pack', name: 'Extra regular theme pack', sortOrder: 10, price: 11, allowQuantity: true, badgeText: 'Qty', badgeColor: 'info' },
            { id: 'addon-sportsnet-beyond', name: 'Sportsnet & Beyond', sortOrder: 20, price: 13 },
            { id: 'addon-tsn-beyond', name: 'TSN & Beyond', sortOrder: 30, price: 13 },
            { id: 'addon-wwe-network', name: 'WWE Network', sortOrder: 40, price: 15 },
            { id: 'addon-fairchild-tv1-hd', name: 'Fairchild TV1 HD', sortOrder: 50, price: 12 },
            { id: 'addon-gma-pinoy-tv', name: 'GMA Pinoy TV', sortOrder: 60, price: 12 },
            { id: 'addon-tfc', name: 'TFC', sortOrder: 70, price: 15 },
            { id: 'addon-south-asian-super-pack', name: 'South Asian Super Pack', sortOrder: 80, price: 16 },
            { id: 'addon-bein-sports', name: 'BeIN Sports Pack', sortOrder: 90, price: 15 },
            { id: 'addon-shudder', name: 'SHUDDER', sortOrder: 100, price: 7 },
            { id: 'addon-acorn-tv', name: 'ACORN TV', sortOrder: 110, price: 10 },
            { id: 'addon-ifc-films', name: 'IFC Films Unlimited', sortOrder: 120, price: 6 },
            { id: 'addon-starz', name: 'STARZ', sortOrder: 130, price: 10 },
            { id: 'addon-discovery-plus', name: 'Discovery+', sortOrder: 140, price: 9 },
            { id: 'addon-abu-dhabi-tv', name: 'Abu Dhabi TV', sortOrder: 150, price: 15 },
            { id: 'addon-all-tv-korean', name: 'All TV Korean', sortOrder: 160, price: 15 },
            { id: 'addon-all-tv-k-korean', name: 'All TV K Korean', sortOrder: 170, price: 15 },
            { id: 'addon-discovery-velocity', name: 'Discovery Velocity', sortOrder: 180, price: 5 },
            { id: 'addon-fairchild-tv1-hd-od', name: 'Fairchild TV1 HD/OD', sortOrder: 190, price: 12 },
            { id: 'addon-nippon-tv', name: 'Nippon TV', sortOrder: 200, price: 7 },
            { id: 'addon-otn-greek', name: 'OTN Greek', sortOrder: 210, price: 15 },
            { id: 'addon-rtvi-russian', name: 'RTVI Russian', sortOrder: 220, price: 15 },
            { id: 'addon-vgn-vietnamese', name: 'VGN TV Vietnamese', sortOrder: 230, price: 9 },
            { id: 'addon-korean-all-tv-pack', name: 'Korean All TV Pack', sortOrder: 240, price: 25 },
            { id: 'addon-japanese-super-pack', name: 'Japanese Super Pack', sortOrder: 250, price: 30 },
            { id: 'addon-russian-pack', name: 'Russian Pack', sortOrder: 260, price: 9 }
        ]
    },
    {
        id: 'wifi-plus',
        title: 'Wifi Plus',
        sortOrder: 30,
        helperText: 'Whole-home Wi-Fi support add-on.',
        items: [
            { id: 'addon-wifi-plus', name: 'Wifi Plus', sortOrder: 10, price: 10, badgeText: 'Wi-Fi', badgeColor: 'success' }
        ]
    },
    {
        id: 'telus-email',
        title: 'TELUS Email',
        sortOrder: 40,
        helperText: 'No monthly charge, included here as a quote note when needed.',
        items: [
            { id: 'addon-telus-email', name: 'TELUS Email', sortOrder: 10, price: 0, note: 'No monthly charge.' }
        ]
    }
];

export const seasonalNotes = [
    'NBA League Pass: seasonal pricing varies.',
    'NHL Centre ICE: seasonal pricing varies.',
    'MLB Extra Innings: seasonal pricing varies.',
    'NFL Sunday Ticket: seasonal pricing varies.'
];

export const installNotes = [
    'Available install times: 8-9, 9-11, 11-1, 1-3, 3-5, 5-7.',
    'Latest preferred weekday slot: 1-3.',
    'Latest preferred weekend slot: 11-1.',
    'TV orders include free pro install valued at $100.',
    'Security installation is separate from internet installation.'
];

// Future Email Shell Manager can control store name, store phone, address, header/footer images, legal text, and per-product email bullets.
export const fallbackEmailShell = {
    storeName: 'TELUS Store @ New Westminster',
    storeAddress: 'Unit 380 - 800 Carnarvon Street, New Westminster, V3M 0G3',
    storePhone: '1-236-835-0807',
    headerImage: 'https://i.imgur.com/8nwlolb.png',
    rabbitHeroImage: 'https://images.ctfassets.net/vob3qda590l9/2dtTEQfJWU0q60gMkeEgk4/3cb82c513f47d694104f4ab27283e697/salesquote_hero_rabbit.jpg',
    onboardingImage: 'https://images.ctfassets.net/zi43rna4epzl/5lgwVrAzJYeSsy06E64K4w/830236779576c2a7329bb5b906a5ccbc/111154238_TELUS_CEM_Onboarding_960px_EMs_R1_02.jpg',
    personIcon: 'https://images.ctfassets.net/vob3qda590l9/2Q14ozXXG8K8uQSgI2mIok/25522c03f6b94846abdb836fd8eb8c92/salesquote_person_icon.jpg',
    wifiIcon: 'https://images.ctfassets.net/vob3qda590l9/6kZ18IOFhuseGgs2gss2k2/0123176a12264b26e96e92eb3d6f1bf0/salesquote_wifi_icon.jpg',
    boxIcon: 'https://images.ctfassets.net/vob3qda590l9/6uiRH11CMw4asCo6QKQKSe/3f0014d963b34977f325c221208e8f58/salesquote_box_icon.jpg',
    critterImage: 'https://images.ctfassets.net/vob3qda590l9/6m9UWmn4EEsUemuceWa066/e20b0381999f81df316aad3c87c9e28b/CEM_Onboarding_OrderConfimation_EM-Copper_Critter2-copy.jpg',
    installIcon: 'https://images.ctfassets.net/vob3qda590l9/Fvo0hplBg2wEkgWMs60gk/be437c9fdcecfbdfd5424ee73b80629c/salesquote_star_icon.jpg',
    neighbourhoodIcon: 'https://images.ctfassets.net/vob3qda590l9/tP0fZGByYoGyUAewOKCSK/1bb154785b05f168646749794b9b6cde/img_neighbour.png',
    facebookIcon: 'https://images.ctfassets.net/vob3qda590l9/6zodj15iWQkeQCwygQm6Kw/5386a0f79f4af3845634470df7838c24/img_facebook.jpg',
    twitterIcon: 'https://images.ctfassets.net/vob3qda590l9/4BHxltQlaoi2MywiCEyWaU/f19ce2375de4c682ab82e14ffff9b07b/img_twitter.jpg',
    footerStoreImage: 'https://i.imgur.com/B3jlo4u.png',
    privacyUrl: 'http://t.e.telus.com/r/?id=he96d4e9,10cec3c5,597344f',
    contactUrl: 'http://t.e.telus.com/r/?id=he96d4e9,10cec3c5,5973450',
    findStoreUrl: 'http://t.e.telus.com/r/?id=he96d4e9,10cec3c5,5973451',
    telusUrl: 'http://t.e.telus.com/r/?id=he96d4e9,10cec3c5,5973452',
    footerLegalHtml: `
        <div>1. Internet access is subject to usage limits; additional charges apply for exceeding the included data.</div>
        <div>&nbsp;</div>
        <div>2. For customers in regulated areas, promotional pricing is available only when Home Phone service is combined with TELUS Internet or TV. Promotional pricing is not available in regulated areas.</div>
        <div>&nbsp;</div>
        <div>TELUS Home Phone service terms and some restrictions apply; visit <a style="color: rgb(178,178,178);" href="http://telus.com/serviceterms" target="_blank">telus.com/serviceterms</a> and <a style="color: rgb(178,178,178);" href="http://telus.com/homephone" target="_blank">telus.com/homephone</a> for details.</div>
        <div>&nbsp;</div>
        <div>&nbsp;</div>
        <div>&nbsp;</div>
        <div>&nbsp;</div>
    `,
    footerLegalFinePrintHtml: `
        <div>A cancellation fee applies to the early termination of your Home Services service agreement, which will be the sum of $360, declining by $15 for every month of service and reduces to $0 at the end of your 2 year term. Taxes apply to cancellation fees and are not included.</div>
        <div>&nbsp;</div>
        <div>This quote is for informational purposes only. Offers can be withdrawn at any time and are subject to change without notice. Final pricing will be confirmed at the time of the transaction. Cannot be combined with other promotional offers. Offers not available in all areas. Minimum system requirements may apply. TELUS reserves the right to modify channel lineups, packaging, equipment and / or in-market pricing without notice. TELUS TV and Internet available to residential customers who have not subscribed to a like service in the past 90 days. Final eligibility for service will be determined by a TELUS representative.</div>
        <div>&nbsp;</div>
        <div>A service agreement with the details of your commitment and a copy of the TELUS Terms of Service, which are also available at: <a style="color: rgb(178,178,178);" href="http://www.telus.com/serviceterms" target="_blank">www.telus.com/serviceterms</a>, will be provided post transaction.</div>
        <div>&nbsp;</div>
        <div>After your term commitment expires, TELUS reserves the right to modify pricing at any time. We will inform you of rate changes at least 60 days in advance for Internet, and 30 days in advance for all other TELUS Home Services, where applicable.</div>
        <div>&nbsp;</div>
        <div>TELUS, the TELUS logo, TELUS PureFibre, Optik TV, Pik TV and <a style="color: rgb(178,178,178);" href="http://t.e.telus.com/r/?id=he954b2c,10cec3c5,5973453" target="_blank">telus.com</a>, are trademarks of TELUS Corporation, used under license. Wi-Fi is a registered trademark of the Wi-Fi Alliance. All copyrights for images, artwork and trademarks are the property of their respective owners.</div>
        <div>&nbsp;</div>
        <div>We would like to hear from you. If you would like to contact us, please click the 'Contact Us' link above.</div>
        <div>&nbsp;</div>
        <div>If you no longer wish to receive TELUS communications, please unsubscribe here.</div>
        <div>&nbsp;</div>
        <div>Marketing Preferences, 30 th Floor, 25 York St. Toronto, ON M5J 2V5</div>
    `
};
